<ngb-tab id="tab-selectbyid91">
    <ng-template ngbTabTitle>Order Review Attachments</ng-template>

    <div class="form-row mt-2">
        <table class="table table-responsivetable-striped" aria-hidden="true">
            <thead>
                <tr>
                    <th scope="col"><b>Image</b></th>
                    <th scope="col" style="width:30%;"><b>File Name</b></th>
                    <th scope="col"><b>Date & Time</b></th>
                    <th scope="col"><b>Created by</b></th>
                    <th scope="col"><b>Action</b></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let doc of orderdoc">
                    <tr>
                        <td *ngIf="orderdoc && doc.FileName!= null && doc.FieldName != 'Onedrive Link'">
                            <img src="{{url + doc.UrlPath}}" alt="" class="img-thumbnail user-attachment-img">
                        </td>
                        <td *ngIf="(orderdoc && doc.FileName == null) || doc.FieldName == 'Onedrive Link'">
                            <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img">
                        </td>

                        <td>{{doc.FieldName}}</td>
                        <td>{{doc.CreatedDate}} {{doc.CreatedTime}}</td>
                        <td>{{doc.CreatedBy}}</td>

                        <td>
                            <div *ngIf="orderdoc && doc.FileName != null && doc.FieldName != 'Onedrive Link'">
                                <div class="d-flex"
                                    *ngIf="permission.OrderReview_AttachmentDownload == 1 || userRId==1">
                                    <a href="javascript:void(0);"
                                        class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                                        placement="bottom" ngbTooltip="Download"
                                        (click)="downloadModal(downloadConfirm, doc.FieldName, downloadurl + doc.FileName)">
                                        <span class="mdi mdi-download mdi-18px"></span>
                                    </a>
                                </div>
                            </div>
                            <div *ngIf="orderdoc && doc.FileName != null && doc.FieldName == 'Onedrive Link'">
                                <div class="d-flex"
                                    *ngIf="permission.OrderReview_AttachmentDownload == 1 || userRId==1">
                                    <a href="javascript:void(0);" target="" (click)="AddHttpfun(oneDriveLink)" class="wrap-text">{{
                                        oneDriveLink }}</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <ng-template #downloadConfirm>
        <div class="modal-body text-center">
            <p>Do you want to Download {{filename}} ?</p>
            <button type="button" class="btn btn-info btn-sm" (click)="download(); modalRef.hide();"
                [disabled]="delNameDel">Download</button>
            <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
        </div>
    </ng-template>

</ngb-tab>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>